import ButtonComponent from './ButtonComponent';

export default ButtonComponent;
